/** @jsx jsx */

import { PropsWithChildren } from 'react';

import { responsiveStyles } from '@zapier/common-utils';
import { css, jsx } from '@emotion/core';

const actionCss = ({ align, size }) => [
  css`
    align-self: ${align};
  `,
  responsiveStyles(size, {
    small: css`
      text-align: center;
      flex: 1 auto;
    `,
    large: css`
      text-align: right;
      flex: 0 0 auto;
    `,
  }),
];

type Props = PropsWithChildren<{
  align: 'start' | 'center' | 'end';
  ariaLabel?: string;
  size: 'small' | 'large';
}>;

const defaultProps = {
  align: 'start',
  size: 'small',
};

function Action({ align, ariaLabel, children, size }: Props) {
  return (
    <div aria-label={ariaLabel} css={actionCss({ align, size })}>
      {children}
    </div>
  );
}

Action.defaultProps = defaultProps;

export default Action;
